import { render, staticRenderFns } from "./edit-card.vue?vue&type=template&id=96655b08&scoped=true&"
import script from "./edit-card.vue?vue&type=script&lang=js&"
export * from "./edit-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96655b08",
  null
  
)

export default component.exports